import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../App';
import { dataFetcher } from '../../Utils/dataFetcher';

import { ComparisonBars } from '../ComparisonBars';
import { RankRow } from './rank-row';

import style from './judges-head-to-head.module.scss';
import { DetailRow } from '../DetailRow';
import { BottomLine } from './bottom-line';
import { AthleteSelector } from '../AthleteSelector';
import { CountryFlag } from '../../Utils/flags';
import { GAtrack } from '../../Utils/tracking';
import { getTrans } from '../../Utils/translate';
import { CosmosImage, CosmosText } from '../../cosmos/web-scoped/react';
import athlete_skeleton from '../AthleteProfileLite/athlete_skeleton.png';
import { capitalize } from '../../Utils/string';

const JudgesHeadToHead = ({ config }) => {
  const [list, setList] = useState();
  const [athletes, setAthletes] = useState();
  // const [activeAthlete, setActiveAthlete] = useState();
  const [comparisonData, setComparisonData] = useState();
  const [details, setDetails] = useState();
  const [athleteLeftId, setAthleteLeftId] = useState();
  const [athleteRightId, setAthleteRightId] = useState();

  const context = useContext(AppContext);
  const uriConfig = context.config.uriConfig;

  const {
    first,
    second,
    third,
    fourth,
    diveDifficulty,
    dive,
    scoreIndicator,
    diveDetails
  } = context.lang;
  const roundName = [
    getTrans(first),
    getTrans(second),
    getTrans(third),
    getTrans(fourth)
  ];

  // console.log(lang, 'lang');

  const fetchData = () => {
    dataFetcher(config.uriList, uriConfig)
      .then((data) => {
        setList(data.entrants);
        setAthleteLeftId(data.entrants[0].athlete.id);
        setAthleteRightId(data.entrants[1].athlete.id);
      })
      .catch(console.error);
  };

  useEffect(() => {
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Navigation`,
        widget_type: `JudgesHeadToHead - ${
          config.trackingTitle || config.navigationTitle
        }`
      }
      // eventCategory: 'video',
      // eventAction: 'sidebar'
      // }
    };

    GAtrack(dataLayerArgs);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (athleteLeftId && athleteRightId) {
      dataFetcher(
        config.uriResults
          .replace('{leftId}', athleteLeftId)
          .replace('{rightId}', athleteRightId),
        uriConfig
      ).then((data) => {
        if (data.athletes) {
          setAthletes([...data.athletes]);
          setDetails([...data.dives]);
          const left = [];
          const right = [];

          if (data.dives) {
            for (let i = 0; i < data.dives.length; i++) {
              const currentDive = data.dives[i];

              if (currentDive.dive_comparison[0]) {
                left.push(currentDive.dive_comparison[0]);
              } else {
                left.push({});
              }
              if (currentDive.dive_comparison[1]) {
                right.push(currentDive.dive_comparison[1]);
              } else {
                right.push({});
              }
            }
          }
          setComparisonData([left, right]);
        }
      });
    }
  }, [athleteLeftId, athleteRightId, config, uriConfig]);

  const splitDecimal = (number) => {
    if (isNaN(number) || !isFinite(number)) return [0, 0];
    const splitNumber = number.toString().split('.');
    return [parseInt(splitNumber[0]), splitNumber[1] ? parseInt(splitNumber[1]) : 0];
  };

  const getMinMax = (values, option = 'min') => {
    if (option === 'min') {
      if (values.length > 0) {
        const parts = splitDecimal(Math.min(...values));
        if (parts[1] === 0) {
          return parts[0] - 0.5;
        } else if (parts[1] < 5) {
          return parts[0];
        } else {
          return parts[0] + 0.5;
        }
      }
      return 0;
    }
    return values.length > 0 ? Math.ceil(Math.max(...values)) : 10;
  };

  const getDifficulty = (option = 'min') => {
    const allValues = [];

    if (comparisonData && comparisonData.length > 0) {
      allValues.push(...comparisonData[0].map((dive) => dive.dive_difficulty));
    }
    if (comparisonData && comparisonData.length > 1) {
      allValues.push(...comparisonData[1].map((dive) => dive.dive_difficulty));
    }

    return getMinMax(allValues, option);
  };

  const getScore = (option = 'min') => {
    const allValues = [];

    if (comparisonData && comparisonData.length > 0) {
      allValues.push(
        ...comparisonData[0]
          .filter((dive) => dive.score_indicator)
          .map((dive) => dive.score_indicator)
      );
    }
    if (comparisonData && comparisonData.length > 1) {
      allValues.push(
        ...comparisonData[1]
          .filter((dive) => dive.score_indicator)
          .map((dive) => dive.score_indicator)
      );
    }

    return getMinMax(allValues, option);
  };

  const handleChange = (e) => {
    const leftId = e[0].value;
    const rightId = e[1].value;
    let newAthlete = {};
    let changedLeft = true;

    if (leftId > 3 && leftId !== 'active' && rightId > 3 && rightId !== 'active') {
      changedLeft = leftId !== athleteLeftId;
      newAthlete =
        leftId !== athleteLeftId
          ? athletes.find(({ athlete }) => athlete.id === leftId).athlete
          : athletes.find(({ athlete }) => athlete.id === rightId).athlete;
    } else {
      changedLeft = leftId !== athleteLeftId;
      newAthlete = leftId !== athleteLeftId ? leftId : rightId;
    }
    const findAthelete = list.find((list) => list.athlete.id === newAthlete);
    // let athleteObj =
    //   Object.keys(newAthlete) > 0 ? newAthlete : { first_name: '', last_name: '' };

    if (e.length === 2) {
      const dataLayerArgs = {
        // dataLayer: {
        event: 'rbVideoTracking',
        event_name: 'video_sidebar',
        video_sidebar: {
          value: `JudgesHeadToHead::${changedLeft ? 'left' : 'right'} side - ${
            findAthelete.athlete.first_name
          } ${findAthelete.athlete.last_name}`,
          widget_type: `JudgesHeadToHead - ${
            config.trackingTitle || config.navigationTitle
          }`
        }
        // eventCategory: 'video',
        // eventAction: 'sidebar'
        // }
      };
      GAtrack(dataLayerArgs);

      setAthleteLeftId(leftId);
      setAthleteRightId(rightId);
    }
  };

  return (
    <>
      {list && (
        <AthleteSelector
          comparison
          options={list
            .sort((a, b) => {
              return `${a.athlete.last_name.toLowerCase()} ${a.athlete.first_name.toLowerCase()}` <
                `${b.athlete.last_name.toLowerCase()} ${b.athlete.first_name.toLowerCase()}`
                ? -1
                : `${a.athlete.last_name.toLowerCase()} ${a.athlete.first_name.toLowerCase()}` >
                  `${b.athlete.last_name.toLowerCase()} ${b.athlete.first_name.toLowerCase()}`
                ? 1
                : 0;
            })
            .map(({ athlete_id, athlete, dynamic, dynamicValue }) => {
              const athleteData = athlete.hasOwnProperty('athlete')
                ? athlete.athlete
                : athlete;
              return {
                label: dynamic ? (
                  <>{dynamic}</>
                ) : (
                  <>
                    {(config.showAthleteImage || config.showSelectAthleteImage) && (
                      <CosmosImage
                        class="option-image"
                        image={
                          athleteData.image
                            ? athleteData.image.profile || athlete_skeleton
                            : athlete_skeleton
                        }
                        image-alt={`image-${athleteData.first_name}-${athleteData.last_name}`}
                      />
                    )}
                    <CosmosText class="option-text" kind="subtle">
                      <img
                        className={`flag`}
                        src={CountryFlag(athleteData.nationality.iso3)}
                        alt={athleteData.nationality.iso3}
                      />
                      {`${capitalize(athleteData.first_name)} ${capitalize(
                        athleteData.last_name
                      )}`}
                    </CosmosText>
                  </>
                ),
                descriptionLabel: dynamic ? dynamic : false,
                selectedLabel: (
                  <>
                    <CosmosText class="option-text" kind="subtle">
                      <img
                        className={`flag`}
                        src={CountryFlag(athleteData.nationality.iso3)}
                        alt={athleteData.nationality.iso3}
                      />
                      {`${capitalize(
                        athleteData.first_name.substring(0, 1)
                      )}. ${capitalize(athleteData.last_name)}`}
                    </CosmosText>
                  </>
                ),
                value: dynamicValue ? dynamicValue : athleteData.id,
                rank: dynamic ? 1 : parseInt(athlete_id)
              };
            })}
          onChange={handleChange}
          value={athleteLeftId}
          comparisonValue={athleteRightId}
        />
      )}
      {comparisonData && (
        <>
          <h3 className={style.headline}>{getTrans(diveDifficulty)}</h3>
          <ComparisonBars
            values={
              comparisonData && comparisonData.length > 0
                ? comparisonData[0].map((dive) => dive.dive_difficulty)
                : []
            }
            opposite={
              comparisonData && comparisonData.length > 1
                ? comparisonData[1].map((dive) => dive.dive_difficulty)
                : []
            }
            segmentWidth={0.5}
            min={getDifficulty('min')}
            max={getDifficulty('max')}
            num={4}
            unitSign=""
            comparisonType={getTrans(dive)}
          />
          <h3 className={style.headline}>{getTrans(scoreIndicator)}</h3>
          <ComparisonBars
            values={
              comparisonData && comparisonData.length > 0
                ? comparisonData[0].map((dive) => dive.score_indicator * 10)
                : []
            }
            opposite={
              comparisonData && comparisonData.length > 1
                ? comparisonData[1].map((dive) => dive.score_indicator * 10)
                : []
            }
            segmentWidth={5}
            min={getScore() * 10}
            max={100}
            num={4}
            unitSign="%"
            comparisonType={getTrans(dive)}
          />
          {athletes && (
            <RankRow
              left={{
                score: athletes[0] ? athletes[0].total_points : undefined,
                rank: athletes[0] ? athletes[0].rank : undefined
              }}
              right={{
                score: athletes[1] ? athletes[1].total_points : undefined,
                rank: athletes[1] ? athletes[1].rank : undefined
              }}
            />
          )}
          <h3 className={style.headline}>{getTrans(diveDetails)}</h3>
          {details &&
            details.map((dive) => {
              const [left, right] = dive.dive_comparison;
              const scoreLeft = left.points || 0;
              const scoreRight = right.points || 0;

              //Todo: For future sports content of rows should be type styled and custom Modules
              return (
                <DetailRow
                  key={`dive-${dive.round_number}`}
                  left={{
                    top: (
                      <>
                        <div
                          className={`${style.score}${
                            scoreLeft >= scoreRight ? ` ${style.highlight}` : ''
                          }`}
                        >
                          {left.points ? scoreLeft.toFixed(2) : ''}
                        </div>
                        <div>DD: {left.dive_difficulty}</div>
                      </>
                    ),
                    bottom: <BottomLine {...left.dive_type} />
                  }}
                  right={{
                    top: (
                      <>
                        <div
                          className={`${style.score}${
                            scoreRight >= scoreLeft ? ` ${style.highlight}` : ''
                          }`}
                        >
                          {right.points ? scoreRight.toFixed(2) : ''}
                        </div>
                        <div>DD: {right.dive_difficulty}</div>
                      </>
                    ),
                    bottom: <BottomLine {...right.dive_type} />
                  }}
                  center={
                    <>
                      {roundName[parseInt(dive.round_number) - 1]}
                      <br />
                      {getTrans(dive)}
                    </>
                  }
                />
              );
            })}
        </>
      )}
    </>
  );
};

export { JudgesHeadToHead };
